<!--class="relative flex flex-row md:max-h-[591px]
     max-w-[344px] md:flex-col no-scrollbar
     overflow-y-scroll overflow-x-scroll  gap-x-[8.8px] sm:gap-x[0px] sm:gap-y-[15px]">-->
<div #thumbNailsContainer
     [ngClass]="[currentScreenSize() === 'LG' ? 'flex-col max-h-[591px] gap-y-[15px]' : 'flex-row gap-x-[8.8px]', currentScreenSize() === 'SM' ? 'max-w-[344px]' : currentScreenSize() === 'MD' ? 'max-w-[599px]' : '', 'relative flex overflow-y-scroll overflow-x-scroll no-scrollbar']">
    @for (thumb of activosDigitales; track thumb ) {
      <button (click)="SelectImage(thumb.urlImg)"
              class="flex"
              [ngClass]="{'rounded border-2 border-verde' : thumb === activosDigitales[selectedImage],
              'opacity-50 border-transparent' : thumb !== activosDigitales[selectedImage] }">
        <img [src]="thumb.urlImg" class="w-[50px] h-[43px] sm:w-[99px] sm:h-[86px] object-cover cursor-pointer flex-none" alt="" />
      </button>
    }
  @if(showMoreElement()) {
    <div class="absolute bottom-0 text-lg sm:text-2xl text-white font-semibold" [ngClass]="{'left-0' : !horizontalMode(), 'right-0' : horizontalMode()}">
      +{{activosDigitalesLenght() - colCount}}
    </div>
  }
</div>
